import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import cs from './i18n/cs.json'
import en from './i18n/en.json'

import './BackendError.css'

function BackendError() {
  const { t, i18n } = useTranslation('BackendError')
  i18n.addResourceBundle('cs', 'BackendError', cs)
  i18n.addResourceBundle('en', 'BackendError', en)

  function refresh() {
    window.location.reload(false)
  }

  return (
    <div className='csas-wrapper csas-section csas-center csas-mt-md' data-testid='backend-error'>
      <div className='row csas-flex'>
        <i className='csas-back-end-error cs-lg-3of12 cs-sm-3of12'></i>
        <span className='csas-error-block cs-lg-9of12 cs-sm-9of12 csas-nopadding'>
          <div className='row csas-flex csas-display-flow'>
            <span className='csas-display-flow csas-orange-text cs-lg-5of12 cs-md-12of12 cs-sm-12of12 csas-nopadding'>
              {t('MessageTitle')}
            </span>
            <span className='csas-display-flow cs-lg-8of12 cs-md-12of12 cs-sm-12of12 csas-flex csas-nopadding'>
              <span className='csas-grey-text'>
                <Trans i18nKey='MessageText' t={t}>
                  Please try <a onClick={refresh}>refreshing</a>
                  the page or contact us on <a href='tel:800207207'>800 207 207</a>
                </Trans>
              </span>
            </span>
          </div>
        </span>
      </div>
    </div>
  )
}

export default BackendError
